// sort conversations messages by it's creation date, oldest first and newest last
export default messages => {
  const sortedMessages = Object.values(messages).sort(
    (messageA, messageB) =>
      messageA.createdAt.seconds - messageB.createdAt.seconds
  );
  return sortedMessages;
};
